import React, { memo, MouseEvent, FC } from 'react';
import { Banner, MessageStatus } from '@nexus/lib-react/dist/core/Banner/Banner';
import styled from '@nexus/lib-react/dist/theme/styled';
import useI18n from '../../../../i18n/hooks/useI18n';
import ActionKycRetry from './ActionKycRetry';
import S from './style/KycWarning';

interface KYCWarningProps {
  onKycRetry: (ev: MouseEvent) => void;
  disabled?: boolean;
}

const StyledBanner = styled(Banner)`
  display: flex;

  p {
    display: flex;
    flex-grow: 1;

    > div {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

const KYCWarning: FC<KYCWarningProps> = ({ onKycRetry, disabled }) => {
  const i18n = useI18n();

  return (
    <S.BannerContainer>
      <S.BannerCentralizer>
        <StyledBanner type={MessageStatus.WARNING}>
          <S.MessageBlock>
            <S.WarningMessage>{i18n`dlv_orders_kyc_retry_needed`}</S.WarningMessage>
            <ActionKycRetry disabled={disabled} onKycRetry={onKycRetry} />
          </S.MessageBlock>
        </StyledBanner>
      </S.BannerCentralizer>
    </S.BannerContainer>
  );
};

export default memo(KYCWarning);
